import { createContext, useContext } from 'react';

import { ISandboxConfig } from '~/src/dash/views/sandbox/config';

interface ISandboxContext {
  cfg: ISandboxConfig;
}

export const SandboxContext = createContext({} as ISandboxContext);
export const useSandboxStore = (): ISandboxContext => useContext(SandboxContext);
